<template>
    <div class="components-downBtn-box">
      <div class="box-btn">
            <div class="btn-box" @click="jumpPath()">
                <img src="https://p3.ssl.qhimg.com/t110b9a930163dda967b4df4f09.png" alt="" />
                立即报名
            </div>
        </div>
    </div>
  </template>
  
  <script setup>
import { showToast } from 'vant'
// import { ref } from 'vue'
  const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
const jumpPath = () => {
  showToast('请前往PC端参与报名！')
}
  </script>
  
  <style lang="scss" scoped>
  .components-downBtn-box {
    position: fixed;
    width: 100%;
    height: 80px;
    left: 0;
    // gap: 9px;
    // right: 16px;
    bottom: 0px;
    display: flex;
    align-items: center;
    background: #ffffff;
    z-index: 99;
    box-shadow: 0 -4px 10px rgba(74, 73, 73, 0.15);
    .box-btn{
        width: 100%;
        display: flex;
        justify-content: center;
        .btn-box{
            cursor: pointer;
            width: 80%;
            height: 46px;
            border-radius: 32px;
            background: linear-gradient(180.00deg, rgb(88, 142, 235),rgb(30, 89, 191) 100%);
            display: flex;
            align-items: center;
            color: rgb(255, 255, 255);
            font-family: Alibaba PuHuiTi 3.0;
            font-size: 16px;
            font-weight: 500;
            justify-content: center;
            img{
                height: 24px;
                margin-right: 12px;
            }
        }
    }
  }
  </style>
  